import { makeStyles } from '@material-ui/core';
import { asg } from '../theme/tokens';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 32,
    // The sidebar ground is asg.navy (see modules/theme, palette.navigation).
    color: asg.white,
  },
  wordmark: {
    fontFamily: asg.fontHeading,
  },
});

/**
 * The ASG horizontal lockup for the open sidebar. This is the knockout form of
 * files/brand/asg-logo-horizontal.svg: that file's wordmark is navy on white
 * and would be invisible against the navy sidebar, so the mark and the type are
 * drawn white / on-navy-muted instead.
 */
export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1040 300"
      role="img"
      aria-label="ASG Advisory Services"
    >
      {/* Mask content is userSpaceOnUse in the MASKED element's own space,
          i.e. inside the translate/scale below - so plain 0..360 icon coords. */}
      <mask id="asgHoleFull">
        <rect width="360" height="360" fill="white" />
        <circle cx="180" cy="180" r="52" fill="black" />
      </mask>
      <g transform="translate(20,20) scale(0.72)">
        <g
          mask="url(#asgHoleFull)"
          fill="none"
          stroke="currentColor"
          strokeWidth="74"
          strokeLinecap="round"
        >
          <line x1="180" y1="180" x2="52" y2="52" />
          <line x1="180" y1="180" x2="52" y2="308" />
          <line x1="180" y1="180" x2="308" y2="52" />
          <line x1="180" y1="180" x2="308" y2="308" />
        </g>
      </g>
      <text
        className={classes.wordmark}
        x="320"
        y="150"
        fontWeight="800"
        fontSize="120"
        fill="currentColor"
        letterSpacing="2"
      >
        ASG
      </text>
      <text
        className={classes.wordmark}
        x="324"
        y="210"
        fontWeight="600"
        fontSize="38"
        fill={asg.onNavyMuted}
        letterSpacing="6"
      >
        ADVISORY SERVICES
      </text>
    </svg>
  );
};
